import { useEffect, useState, createContext, useContext } from "react";
import { api, auth } from "@/lib/api";
import { toast } from "sonner";

const ServerContext = createContext(null);

export function ServerProvider({ children }) {
  const [guilds, setGuilds] = useState([]);
  const [active, setActive] = useState(null);
  const [botInviteUrl, setBotInviteUrl] = useState("");
  const [loading, setLoading] = useState(true);

  const refresh = async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/auth/me/guilds");
      setGuilds(data.guilds || []);
      setBotInviteUrl(data.bot_invite_url || "");
      const stored = localStorage.getItem("606_active_guild");
      const found = data.guilds?.find((g) => g.id === stored);
      const bestDefault = data.guilds?.find((g) => g.bot_present) || data.guilds?.[0] || null;
      setActive(found || bestDefault);
    } catch (e) {
      // 401? clear
      if (e?.response?.status === 401) auth.clear();
    } finally {
      setLoading(false);
    }
  };

  const select = (g) => {
    setActive(g);
    if (g) localStorage.setItem("606_active_guild", g.id);
  };

  useEffect(() => { refresh(); }, []);

  return (
    <ServerContext.Provider value={{ guilds, active, select, refresh, botInviteUrl, loading }}>
      {children}
    </ServerContext.Provider>
  );
}

export const useServer = () => {
  const ctx = useContext(ServerContext);
  if (!ctx) throw new Error("useServer must be used inside ServerProvider");
  return ctx;
};

export const useGuildId = () => {
  const { active } = useServer();
  return active?.id || null;
};

export const requireBotPresent = (active, botInviteUrl) => {
  if (!active) {
    toast.error("Select a server first");
    return false;
  }
  if (!active.bot_present) {
    toast.error("Bot is not in this server. Click 'Add Bot'.");
    if (botInviteUrl) window.open(botInviteUrl, "_blank");
    return false;
  }
  return true;
};
